module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('reporting-id')) ? _c('div', {
    staticClass: "field-reporting-id"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("RP" + _vm._s(_vm.item.id))])]) : (_vm.$is('reporting-name')) ? _c('div', {
    staticClass: "field-reporting-name"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.type.name))])]) : (_vm.$is('reporting-driver-info')) ? _c('div', {
    staticClass: "field-reporting-driver-info"
  }, [_c('driver', {
    attrs: {
      "type": 'oneLook',
      "item": _vm.item.driver
    }
  }), _c('driver', {
    attrs: {
      "type": 'driverName',
      "item": _vm.item.driver
    }
  })], 1) : (_vm.$is('reporting-location')) ? _c('div', {
    staticClass: "field-reporting-location"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Location")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.location))])]) : (_vm.$is('reporting-vehicle')) ? _c('div', {
    staticClass: "field-reporting-vehicle"
  }, [_c('vehicle', {
    attrs: {
      "type": 'oneLook',
      "item": _vm.item.vehicle
    }
  })], 1) : (_vm.$is('reporting-reported-at')) ? _c('div', {
    staticClass: "field-reporting-reported-at"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Reported at")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('reporting-updated-at')) ? _c('div', {
    staticClass: "field-reporting-updated-at"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Updated at")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.updated, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('reporting-status')) ? _c('div', {
    staticClass: "field-reporting-status"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_c('status', {
    attrs: {
      "status": _vm.item.status
    }
  })], 1), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5056697e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/ReportingFields.vue
// module id = 2488
// module chunks = 1